import { sprintf } from 'sprintf-js';

import { Icon } from 'components/Icon/Icon';
import { Pill } from 'components/Pill/Pill';
import { PillCloseButton } from 'components/Pill/Pill.styled';

export function SearchFiltersSidebarFilterPill({
  text,
  clearFilter,
}: {
  text: string;
  clearFilter: () => void;
}) {
  return (
    <Pill
      qaId="filter-pill"
      title={sprintf(getText(`Clear %(option)s filter`), {
        option: text,
      })}
      suffix={
        <PillCloseButton type="button" onClick={clearFilter}>
          <Icon name="close" size={14} />
        </PillCloseButton>
      }
    >
      {text}
    </Pill>
  );
}
